module.exports = "../../app/cells/pages/guides/v2_hero_banner_cell.rb";